/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CostTypeDto interface.
 */
export function instanceOfCostTypeDto(value) {
    return true;
}
export function CostTypeDtoFromJSON(json) {
    return CostTypeDtoFromJSONTyped(json, false);
}
export function CostTypeDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'value': json['value'] == null ? undefined : json['value'],
        'description': json['description'] == null ? undefined : json['description'],
        'visibile': json['visibile'] == null ? undefined : json['visibile'],
        'placeholder': json['placeholder'] == null ? undefined : json['placeholder'],
        'duplicable': json['duplicable'] == null ? undefined : json['duplicable'],
    };
}
export function CostTypeDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'value': value['value'],
        'description': value['description'],
        'visibile': value['visibile'],
        'placeholder': value['placeholder'],
        'duplicable': value['duplicable'],
    };
}
